export default __webpack_public_path__ + "static/media/SF-Pro-Rounded-Regular.11e4778b.otf";